/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ShoppingWithGrid_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SharedFavoritesProvider_viewer">;
    readonly " $refType": "ShoppingWithGrid_viewer";
};
export type ShoppingWithGrid_viewer$data = ShoppingWithGrid_viewer;
export type ShoppingWithGrid_viewer$key = {
    readonly " $data"?: ShoppingWithGrid_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ShoppingWithGrid_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ShoppingWithGrid_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SharedFavoritesProvider_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '766a19579b084d8ddee50987760c5f3a';
export default node;
